import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import BaseButton from 'src/common/components/base-button';
import { setHomePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Barcode } from 'src/common/media/transaction_24px.svg';
import { AppState } from 'src/common/redux/configure-store';
import { trainingModeStyles } from 'src/common/training-mode/training-mode-styles';
import { ScannedDataHandler } from 'src/devices/scanner-operations';
import SalesKeypad from 'src/sales-keypad/components/sales-keypad';
import { voidByCodeStyles } from './void-item-by-code-styles';

type Props = VoidByCodeProps;

export const showVoidByCodeWindow = (props: Props, scanCallback: ScannedDataHandler): void => {
  setHomePage(<VoidItemByCode {...props} />, scanCallback, { enablePluMenu: true });
};

const VoidItemByCode: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = voidByCodeStyles();

  const { t } = useTranslation();
  const trainingModeClasses = trainingModeStyles();

  const leftHanded = useSelector((state: AppState): boolean => state.cashierPreferences.leftHanded);
  const trainingMode = useSelector((state: AppState): boolean => state.posMode.trainingMode);

  return (
    <Grid
      item
      className={`fullHeight flexFull ${classes.outerMostContainer}`}
      data-testid='void-by-code'
    >
      <Grid
        item
        className={`${
          trainingMode ? trainingModeClasses.trainingModeBackground : classes.background
        } fullWidth fullHeight`}
      >
        <Grid
          container
          direction='column'
          className={`fullHeight ${classes.voidByCodeContainer} ${classes.outerFlexDesign}`}
          data-testid='void-by-code-container'
        >
          <Grid
            container
            direction='column'
            justifyContent='center'
            className={`${classes.voidByCodeTitleContainer} fullWidth`}
            data-testid='void-by-code-title'
          >
            <Grid item className={classes.fitHeight}>
              <Grid
                container
                direction='column'
                className={`${classes.voidByCodeTitleContainer} fullWidth`}
              >
                <Typography
                  className={`${classes.voidByCodeTitleHeader} ${classes.voidByCodeTitleHeaderLabel}`}
                  data-testid='void-by-code-title-text'
                >
                  {t('SetCancelItemStateCommand')}
                </Typography>
                <Grid item xs={1}>
                  <Typography className={`${classes.voidByCodeTitleBar}`} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            container
            className={classes.flexDesign}
            direction={leftHanded ? 'row-reverse' : 'row'}
          >
            <Grid item container xs={9}>
              <Grid item container className={classes.containerAlignment}>
                <Typography
                  className={`${classes.voidByCodeTitleHeader} ${classes.voidByCodeTitleHeaderLabel}`}
                  data-testid='void-by-code-body-text'
                >
                  {t('Void_Item_By_Code_SubTitle')}
                </Typography>
                <Grid container justifyContent='center'>
                  <Barcode className={classes.icon} />
                </Grid>
              </Grid>
              <Grid item container justifyContent='center' className={classes.selfAlign}>
                <BaseButton
                  buttonType='white'
                  className={classes.buttonStyles}
                  onClick={props.onCancel}
                  data-testid='void-by-code-cancel-button'
                >
                  {t('CancelLoyalty')}
                </BaseButton>
              </Grid>
            </Grid>
            <Grid item className={classes.keypadContainer}>
              <SalesKeypad
                keyboardId='void-item-by-code'
                disableSubmitWhenNoInput={true}
                isKeypadVisible
                dataTestIdModifier='void-by-code'
                keyPadSubmit={props.onKeypadSubmit}
                disableManualWeight
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

interface VoidByCodeProps {
  onCancel: () => void;
  onKeypadSubmit: (itemCode: string) => void;
}

export default VoidItemByCode;
